export default {"src":"/_next/static/media/ic-bank.d150b6d5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};